module.exports = __webpack_public_path__ + "static/img/new_about4.743ef39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/new_about4.png
// module id = JvYw
// module chunks = 1